import React from 'react';
import UserManagementTab from '../UserManagementTab';

const AdminUsersTab = () => {
    return <UserManagementTab />;
};

export default AdminUsersTab;
